import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './material-source.reducer';

export const MaterialSourceDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const materialSourceEntity = useAppSelector(state => state.materialSource.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="materialSourceDetailsHeading">
          <Translate contentKey="coconApp.materialSource.detail.title">MaterialSource</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{materialSourceEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="coconApp.materialSource.name">Name</Translate>
            </span>
          </dt>
          <dd>{materialSourceEntity.name}</dd>
        </dl>
        <Button tag={Link} to="/material-source" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/material-source/${materialSourceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MaterialSourceDetail;
